export function localNavigationPath(
  path: string,
  scope: { organization_id: string; legal_entity_id: string },
): string {
  const target = new URL(path, "https://accounting.invalid");
  if (scope.organization_id) {
    target.searchParams.set("organization_id", scope.organization_id);
  }
  if (scope.legal_entity_id) {
    target.searchParams.set("legal_entity_id", scope.legal_entity_id);
  }
  return `${target.pathname}${target.search}${target.hash}`;
}
